export default __webpack_public_path__ + "static/media/spark_67.75354693.png";